<template>
  <div class="visual-element-ar">
    <FormVisualElement class="col-1/2" @valid="$emit('valid', $event)">
      <FormRow
        label="Link di riferimento "
        :for-id="`visual-element-ar-link-${_id}`"
        name="Link"
        rules="required|link"
      >
        <v-input
          :id="`visual-element-ar-link-${_id}`"
          type="url"
          name="url"
          v-model="modelDataElement.url"
        />
      </FormRow>

      <FormRow
        label="Titolo"
        legend="(fino ad un massimo di XXX caratteri)"
        :for-id="`visual-element-ar-title-${_id}`"
        name="Titolo"
        rules="required"
      >
        <v-input
          :id="`visual-element-ar-title-${_id}`"
          type="text"
          name="title"
          v-model="modelDataElement.title"
        />
      </FormRow>

      <FormRow
        label="Sottotitolo"
        legend="(fino ad un massimo di XXX caratteri)"
        :for-id="`visual-element-ar-subtitle-${_id}`"
        name="Sottotitolo"
        rules="required"
      >
        <v-input
          :id="`visual-element-ar-subtitle-${_id}`"
          type="text"
          name="subtitle"
          v-model="modelDataElement.subtitle"
        />
      </FormRow>

      <FormRow
        label="Immagine di background"
        :for-id="`visual-element-ar-image-${_id}`"
        legend="(dimensioni minime suggerite 750x508 px)"
        name="Immagine"
      >
        <v-image-input
          :id="`visual-element-ar-image-${_id}`"
          :podcastId="podcastId"
          :imageWidth="750"
          :imageHeight="508"
          name="src"
          v-model="modelDataElement.src"
          :isVisualElement="true"
        />
      </FormRow>
    </FormVisualElement>
  </div>
</template>

<script>
/** Components */
import VisualElementBase from '@/components/VisualElementBase.vue'

export default {
  extends: VisualElementBase,

  defaultContent: {
    url: '',
    title: '',
    subtitle: '',
    src: '',
  },
}
</script>
